// extracted by mini-css-extract-plugin
module.exports = {"container_grid_cardsGame":"genres_container_grid_cardsGame__3N-0e","containerNotExistedGameCombination":"genres_containerNotExistedGameCombination__2Ty_M"};